import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// material-ui
import { ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";

// ==============================|| NAV ITEM ||============================== //

const NavItem = ({ item, selectedItems, setSelectedItems, open, handleDrawerToggle }) => {
  const handleSelect = (id) => {
    setSelectedItems(id);
  };

  const Icon = item.icon;
  const itemIcon = Icon ? <Icon size={20} /> : null;

  return (
    <ListItemButton
      component={Link}
      to={item.url}
      selected={selectedItems === item.id}
      onClick={() => handleSelect(item.id)}
      sx={(theme) => ({
        position: "relative",
        color: "#5a5a3a",
        mx: open ? 1 : 0.6,
        borderRadius: open ? 1.25 : 2,
        pl: open ? 2.25 : 1.6,
        pr: open ? 1.25 : 0.8,
        py: 0.75,
        transition: theme.transitions.create(["background-color", "box-shadow"], {
          duration: theme.transitions.duration.shorter,
        }),
        "&:hover": {
          backgroundColor: "rgba(2, 70, 46, 0.06)",
          color: "#02462E",
        },
        "&.Mui-selected": {
          background: "#02462E",
          boxShadow: "0 2px 8px rgba(2,70,46,0.2)",
          color: "#FEC700 !important",
          "& .MuiListItemIcon-root": { color: "#FEC700 !important" },
          "& .MuiTypography-root": { color: "#FEC700 !important" },
          "& span": { color: "#FEC700 !important" },
        },
        "&.Mui-selected:hover": {
          background: "#023d28",
        },
        "&.Mui-selected::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 6,
          bottom: 6,
          width: 3,
          backgroundColor: "#FEC700",
          borderRadius: "0 2px 2px 0",
        },
      })}
    >
      <ListItemIcon sx={{ minWidth: 30, color: "inherit" }}>{itemIcon}</ListItemIcon>
      {open && (
        <ListItemText
          sx={{ minWidth: 0 }}
          primary={
            <Typography
              variant="body1"
              color="text.primary"
              sx={{ fontSize: "0.84rem", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
            >
              {item.title}
            </Typography>
          }
        />
      )}
    </ListItemButton>

  );
};

export default NavItem;
